const LOGO_VERSION = '1.0.1' //change for cache busting
export const LOGO_URLS = {
  SMALL: `/images/logos/logo-mc-small.svg?ver=${LOGO_VERSION}`,
  NORMAL: `/images/logos/logo-mc.svg?ver=${LOGO_VERSION}`,
  SMALL_WHITE: `/images/logos/logo-mc-small-white.svg?ver=${LOGO_VERSION}`,
  NORMAL_WHITE: `/images/logos/logo-mc-white.svg?ver=${LOGO_VERSION}`,
}
